import { useState } from "react";

import { useSalesTasks } from "./useSalesTasks";

export type TaskType = "sales" | "room" | "event";

export interface UseTaskDashboardOptions {
  initialTaskType?: TaskType;
}

export const useTaskDashboard = (options: UseTaskDashboardOptions = {}) => {
  const { initialTaskType = "sales" } = options;
  
  // Track the current task type
  const [currentTaskType, setCurrentTaskType] = useState<TaskType>(initialTaskType);
  
  // Fetch sales tasks using the existing hook
  const salesTasks = useSalesTasks();
  
  // We'll add room and event tasks later
  // For now, just return the sales tasks
  
  return {
    currentTaskType,
    setCurrentTaskType,
    salesTasks: {
      myTasks: salesTasks.myTasks,
      tasksDueSoon: salesTasks.tasksDueSoon,
      isLoading: salesTasks.tasksDueSoonStatus === "pending",
      handleCompleteTask: salesTasks.handleCompleteTask,
      handleCreateTask: salesTasks.handleCreateTask,
      handleDeleteTask: salesTasks.handleDeleteTask,
      handleReassignTask: salesTasks.handleReassignTask,
    },
    // We'll add these later
    roomTasks: {
      myTasks: [],
      isLoading: false,
    },
    eventTasks: {
      myTasks: [],
      isLoading: false,
    },
  };
};
